<template>
  <helper-layout :loaded="mx_loaded">
    <v-layout v-if="allAccountList.accounts" style="margin-bottom:20px;max-height: 180px;">
      <div
        v-for="(accountLi, i) in allAccountList.accounts"
        :key="i"
        class="account-flex"
      >
        <v-card class="balance-card">
          <v-flex align-self-center>
            <div class="total-title">
              {{ accountLi.accountName }}{{ $t("Views.Finance.totalBalance") }}
            </div>
          </v-flex>
          <v-flex align-self-center>
            <div class="total-value primary-text">
              {{ $util.data.moneyFmt(accountLi.balance, i === 0 ? 'JPY': 'USD') }}
            </div>
          </v-flex>
        </v-card>
        <v-card class="balance-card">
          <v-flex align-self-center>
            <div class="total-title">
              {{ accountLi.accountName }}{{ $t("Views.Finance.totalFreezeAmount") }}
            </div>
          </v-flex>
          <v-flex align-self-center>
            <div class="total-value">
              {{ $util.data.moneyFmt(accountLi.freezeAmount, i === 0 ? 'JPY': 'USD') }}
            </div>
          </v-flex>
        </v-card>
      </div>
    </v-layout>

    <material-table
      :headers="headers"
      :search-data="searchData"
      :paginate="paginateConfig"
      :items="items"
      :total-count="allAccountList.data.totalCount"
      :sort-data.sync="sortData"
      @pageChange="handlePageChange"
      @searchChange="handleSearchChange"
      @sortChange="handleSortChange"
    >
      <!-- 表格顶部工具栏 -->
      <!-- <template v-slot:toolbar>
        <v-layout justify-end class="toolbar">
          <v-flex shrink>
            <v-btn
              v-if="getPermission('FinanceManager.FinanceAccount.ImportBankStatement')"
              solid
              @click="importFlow()"
            >
              {{ $t("Views.Finance.importFlow") }}
            </v-btn>
          </v-flex>
        </v-layout>
      </template> -->
    </material-table>

    <!-- 充值 -->
    <material-dialog
      :eable-btn="!enableSubmitButton"
      :visible="showRechargeDialog"
      :title="$t('Views.Finance.customerRecharge')"
      width="600"
      @cancleFn="handleCloseRechargeDialog"
      @confirmFn="handleConfirmRechargeDialog"
    >
      <template>
        <div>
          <v-form ref="rechargeForm">
            <v-layout column>
              <v-flex>
                <v-layout align-center>
                  <v-flex v-if="selectedAccount" class="fix-left">
                    <v-text-field
                      v-model="customerName"
                      disabled
                      :label="$t('Views.Finance.client')"
                      style="font-size:14px;"
                    />
                  </v-flex>
                </v-layout>
              </v-flex>

              <v-flex>
                <v-layout align-center>
                  <span class="required-mark">*</span>
                  <v-flex class="fix-left">
                    <v-select
                      v-model="account"
                      return-object
                      :items="accountItems"
                      :item-value="items => items.id"
                      :item-text="items => items.label"
                      :label="$t('Views.Finance.accountName')"
                      :placeholder="$t('Views.Finance.setAccount')"
                      :rules="rechargeAccountRules"
                      :no-data-text="$t('Views.Goods.noData')"
                      @change="value => onAccountClick(value)"
                    />
                  </v-flex>
                </v-layout>
              </v-flex>

              <v-flex>
                <v-layout align-center>
                  <v-flex
                    v-show="account"
                    class="fix-left"
                    style="margin-top:-10px;"
                  >
                    {{ $t("Views.Finance.balance") }} ：{{
                      account ? formatPrice(account.balance) : ""
                    }}
                  </v-flex>
                </v-layout>
              </v-flex>
              <!-- 充值方式 -->
              <v-flex>
                <v-layout align-center>
                  <span class="required-mark">*</span>
                  <v-flex class="fix-left">
                    <v-select
                      v-model="paymentMethodName"
                      :items="rechargeMethods"
                      :item-value="items => items.name"
                      :item-text="items => items.name"
                      :label="$t('Views.Finance.recharge_method')"
                      :placeholder="$t('Views.Finance.select_recharge_method')"
                      :rules="rechargeMethodRules"
                      :no-data-text="$t('Views.Goods.noData')"
                    />
                  </v-flex>
                </v-layout>
              </v-flex>

              <v-flex>
                <v-layout align-center>
                  <span class="required-mark">*</span>
                  <v-flex class="fix-left">
                    <v-text-field
                      v-model="rechargeAmount"
                      :validate-on-blur="true"
                      maxlength="9"
                      :rules="rechargeAmountRules"
                      :label="$t('Views.Finance.rechargeAmount')"
                      :placeholder="$t('Views.Finance.setAmount')"
                      @input="onRechargeAmountInput"
                    />
                  </v-flex>
                </v-layout>
              </v-flex>

              <v-flex>
                <v-layout align-center>
                  <span class="required-mark">*</span>
                  <v-flex class="fix-left">
                    <material-dateTime
                      v-model="date"
                      type="date"
                      display-format="YYYY-MM-DD"
                      icon="mdi-clock-outline"
                      no-title
                      :rules="rules.date"
                      :label="$t('Views.Finance.dateTime')"
                      :max-date="currentTime"
                      @input="value => handleInputDate(value)"
                    />
                  </v-flex>
                </v-layout>
              </v-flex>

              <v-flex>
                <v-layout>
                  <v-flex class="fix-left">
                    <v-textarea
                      v-model="remark"
                      counter
                      :label="$t('Views.Finance.remark')"
                      maxlength="50"
                      name="input-7-1"
                    />
                  </v-flex>
                </v-layout>
              </v-flex>

            </v-layout>
          </v-form>
        </div>
      </template>
    </material-dialog>
    <!-- 确认弹窗 -->
    <material-dialog
      :visible="showConfirmDialog"
      :title="$t('Views.Finance.sure')"
      width="500"
      @cancleFn="handleCloseRechargeDialog('confirm')"
      @confirmFn="handleConfirmRechargeDialog('confirm')"
    >
      <template>
        <span>
          {{ $t("Views.Finance.sureRecharge",{
            '1': account ? account.label : '',
            '2': rechargeAmount ? `${account&&account.name==='JPY'?'￥':'$'}${formatPrice(rechargeAmount)}` : ''}) }}
        </span>
      </template>
    </material-dialog>

  </helper-layout>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { pageLoadMx } from '@/plugins/mixins'
import { format, startOfDay } from 'date-fns'
import ENUMS from '@/dict/enums'
// import TOOL from '@/utils/tool'
const TODAY = format(startOfDay(new Date()), 'YYYY-MM-DD')
export default {
  mixins: [pageLoadMx],
  data() {
    const $t = this.$t.bind(this)
    return {
      customerName: '',
      showRechargeDialog: false,
      showConfirmDialog: false,
      modalTitle: '',
      selectedAccount: null,
      accountItems: [],
      account: null,
      amount: '',
      rechargeAmount: '',
      date: TODAY,
      currentTime: format(new Date(), 'YYYY-MM-DD'),
      remark: '',
      attachment: [],
      uploadLimit: 1,
      headers: [],
      searchData: [
        {
          key: 'customerFilter',
          value: '',
          // 客户
          label: $t('Views.Finance.customer_search_label'),
          placeholder: $t('Views.Finance.nameOrSN')
        },
        {
          // 销售
          key: 'salesId',
          name: $t('Views.Finance.sales'),
          placeholder: $t('Views.Finance.pleaseSelectSales'),
          type: 'select',
          itemText: 'name',
          itemValue: 'id',
          itemState: 'items',
          id: '',
          items: []
        }
      ],
      paginateConfig: {
        page: 1,
        pageSize: 10,
        total: 0
      },
      form: {
        skipCount: 0,
        maxResultCount: 10
      },
      items: [],
      sortData: {
        descending: false
      },
      showDialog: false,
      rechargeMethods: [],
      paymentMethodName: null,
      rules: {
        date: [this.$util.rules.emptyRule($t('Views.Finance.dateTime'))]
      },
      JPY: 'JPY'
    }
  },
  computed: {
    ...mapState('finance', [
      'rechargesData',
      'history',
      'allAccountList',
      'accountList'
    ]),
    ...mapState('setting', ['staffAllData', 'paymentMethodsAll']),
    accountName() {
      return this.account ? this.account.name : ''
    },
    enableSubmitButton() {
      return this.account && this.rechargeAmount !== '' && this.date !== null
    },
    rechargeAmountRules() {
      if (this.rechargeAmount !== '') {
        const m = parseFloat(this.rechargeAmount)
        if (isNaN(m)) {
          const rule = value => {
            // 特殊字符
            if (/[^\u4e00-\u9fa5a-zA-Z0-9\w]/g.test(value)) {
              return this.$t('Views.Finance.correctAmount')
            } else {
              const v = value.match(/^\d*(\.?\d{0,2})/g)
              if (v != null && v.length === 1 && v[0] === '') {
                return this.$t('Views.Finance.correctAmount')
              } else {
                return true
              }
            }
          }
          return [rule]
        } else {
          if (m <= 0) {
            return [this.$t('Views.Finance.noSmallerAmount')]
          } else {
            const i = this.rechargeAmount.indexOf('.')
            if (i !== -1) {
              const strs = this.rechargeAmount.split('.')
              if (strs.length >= 2) {
                // 判断小数点 左右两边是否是数字
                const left = strs[0]
                const right = strs[1]
                if (left === '' || right === '') {
                  return [this.$t('Views.Finance.correctAmount')]
                } else {
                  return []
                }
              } else {
                return []
              }
            } else {
              return []
            }
          }
        }
      } else {
        return [this.$t('Views.Finance.noEmptyAmount')]
      }
    },
    rechargeAccountRules() {
      if (this.account) {
        return []
      } else {
        return [this.$t('Views.Finance.noEmptyAccount')]
      }
    },
    rechargeMethodRules() {
      if (this.paymentMethodName) {
        return []
      } else {
        return [this.$t('Views.Finance.recharge_methods_needed')]
      }
    }
  },

  mounted() {
    this.getStaffList()
    this.getPage()
  },

  methods: {
    ...mapActions('finance', [
      'getAllAccountList',
      'getAllAccountListExcel',
      'getAccountList',
      'recharge'
    ]),
    ...mapActions('setting', ['getStaffAllData', 'getPaymentMethodsAll']),
    getPage(page) {
      if (typeof page !== 'undefined') {
        this.paginateConfig.page = page
        this.form.skipCount = (page - 1) * this.form.maxResultCount
      }
      if (!this.mx_loaded) this.mx_loading_fn() // 页面加载中
      const items = []
      const headers = []
      this.getAllAccountList(this.form).then(() => {
        this.allAccountList.headers.forEach((header, i) => {
          if (i === 0) {
            headers.push({
              text: header.text,
              value: header.fieldName,
              align: 'left',
              renderHeader: (h, params) => {
                return h(
                  'div',
                  {
                    domProps: {
                      innerHTML: this.$t('Views.Order.clientName') + '<br/>' + this.$t('Views.Order.newCustomerNumList')
                    }
                  })
              },
              render: (h, param) => {
                let infoText = param.row['Customer.CustomerNewInfo']
                infoText = infoText.replace(/\\r\\n/g, '<br />')
                return h('div', {
                  domProps: {
                    innerHTML: infoText
                  }
                })
              }
            })
          } else {
            headers.push({
              text: header.text,
              value: header.fieldName,
              sort: header.isSort,
              // isCurrency: i === 2 || i === 3 || i === 4 || i === 5,
              align: i === 2 || i === 3 || i === 4 || i === 5 ? 'right' : 'left',
              render: (h, params) => {
                if (i === 2 || i === 3 || i === 4 || i === 5) {
                  return h('span', this.$util.data.moneyFmt(params.row[header.fieldName], (i === 2 || i === 3) ? 'JPY' : 'USD'))
                } else {
                  return h('span', params.row[header.fieldName])
                }
              }
            })
          }
        })
        this.paginateConfig.total = this.allAccountList.data.totalCount
        this.allAccountList.data.items.forEach(item => {
          var newObject = {}
          headers.forEach((header, idx) => {
            newObject[header.value] = item.data[idx]
          })
          newObject['id'] = item.id
          newObject['status'] = item.status
          items.push(newObject)
        })
        headers.push({
          // '操作'
          text: this.$t('Views.Finance.action'),
          value: 'action',
          actions: [
            // {
            //   // 充值
            //   text: this.$t('Views.Finance.recharge'),
            //   color: this.$store.state.app.payBtnColor,
            //   visible: this.getPermission('FinanceManager.FinanceAccount.Recharge'),
            //   actionFn: row => {
            //     this.rechargeClick(row)
            //   }
            // },
            {
              // 查看充值列表
              text: this.$t('Views.Finance.viewBills'),
              color: this.$store.state.app.payInfoBtnColor,
              visible: this.getPermission('FinanceManager.RechargeList'),
              actionFn: row => {
                const info = row.row['Customer.CustomerNewInfo'].replace(/\\r\\n/g, ' ')
                const name = info.split(' ')[0]
                this.$router.push({
                  name: 'rechargeList',
                  query: { customerFilter: name }
                })
              }
            },
            {
              // 查看明细
              text: this.$t('Views.Finance.viewDetails'),
              color: this.$store.state.app.color,
              visible: this.getPermission('FinanceManager.IncomeAndExpenditureDetails'),
              actionFn: row => {
                this.$router.push({
                  name: 'incomeExpenditure',
                  params: { id: row.row.id, item: row.row }
                })
              }
            }
          ]
        })
        this.headers = headers
        this.items = items
        this.mx_loaded_fn() // 页面加载完成
      }).finally(() => {
        this.mx_loaded_fn()
      })
    },
    getStaffList() {
      this.getStaffAllData({ isActive: true, permissionCheck: true }).then(() => {
        this.searchData[1].items = this.staffAllData.items
        // this.searchData[2].items = this.staffAllData.items
      })
    },
    handleSearchChange(search) {
      this.form = { ...this.form, ...search }
      this.getPage(1)
    },
    handlePageChange(page) {
      this.getPage(page)
    },
    handleSortChange(sort) {
      const value_sort = `${sort.sortBy}`
      const value_desc = sort.descending ? ' desc' : ''
      const value = value_sort + value_desc

      if (value === this.form.sorting) return
      this.form.sorting = value
      this.getPage()
    },
    handleSelectChange(selected) {
      this.selectData = selected
    },
    importFlow() {
      this.$router.push({ path: '/account_statement/import_waterbill' })
    },
    handleCloseRechargeDialog(type) {
      if (type === 'confirm') {
        this.showConfirmDialog = false
      } else {
        (this.$refs.rechargeForm).resetValidation()
        this.resetForm()
        this.showRechargeDialog = false
        // (this.$refs.imgupload).resetLimit()
      }
    },
    handleConfirmRechargeDialog(type) {
      const _this = this
      if (type === 'confirm') {
        if (this.$refs.rechargeForm.validate()) {
          this.mx_loading_fn() // 页面加载中
          if (this.account && this.rechargeAmount !== '') {
            // const pictureKeyEdit =
            //   this.attachment.length > 0 ? this.attachment[0].pictureKey : ''
            const params = {
              customerAccountId: this.account.id,
              paymentMethodName: this.paymentMethodName,
              amount: this.rechargeAmount,
              rechargeTime: this.date,
              remark: this.remark
              // customerId: this.account.customerId,
              // pictureKey: pictureKeyEdit
            }
            const type = 'post'
            this.recharge({ type, params })
              .then(() => {
                this.$store.commit('app/setNotification', {
                  msg: this.$t('Views.Finance.successRecharge'),
                  type: 'success'
                })
                _this.showConfirmDialog = false
                _this.showRechargeDialog = false
                _this.getPage()
                _this.resetForm()
                // _this.$refs.imgupload.resetLimit()
                _this.mx_loaded_fn() // 页面加载完成
              })
              .catch(err => {
                this.$store.commit('app/setNotification', {
                  msg: err.error.message,
                  type: 'error'
                })
                _this.showRechargeDialog = false
                _this.showConfirmDialog = false
                _this.resetForm()
                // _this.$refs.imgupload.resetLimit()
              })
              .finally(() => {
                _this.showRechargeDialog = false
                _this.showConfirmDialog = false
                _this.mx_loaded_fn() // 页面加载完成
              })
          } else {
            _this.$store.commit('app/setNotification', {
              msg: _this.$t('Views.Finance.wrongData'),
              type: 'error'
            })
          }
        }
      } else {
        if ((this.$refs.rechargeForm).validate()) {
          if (this.account && this.account.name === 'JPY') {
            if (!/^\+?[1-9][0-9]*$/.test(this.rechargeAmount)) {
              this.$store.commit('app/setNotification', { msg: this.$t('Views.Finance.wrongRechargeAmount'), type: 'error' })
              return
            }
          }
          this.showConfirmDialog = true
        }
      }
    },
    resetForm() {
      this.date = TODAY
      this.amount = ''
      this.rechargeAmount = ''
      this.remark = ''
      this.attachment = []
      this.account = null
      this.paymentMethodName = null
    },
    rechargeClick(row) {
      if (row.row.status === 'Active') {
        this.selectedAccount = row.row
        if (this.selectedAccount) {
          this.getAccount(row.row.id)
          this.customerName = `${this.selectedAccount['Customer.CustomerInfo'].split('\\r\\n')[0]}（${this.selectedAccount['Customer.CustomerInfo'].split('\\r\\n')[1]}）`
        }
        this.getRechargeMethods()
        this.showRechargeDialog = true
      } else {
        this.$store.commit('app/setNotification', {
          msg: this.$t('Views.Finance.noRchargeForBanned'),
          type: 'error'
        })
      }
    },
    getAccount(id) {
      this.getAccountList(id)
        .then(() => {
          this.accountItems = this.accountList.items
          this.accountItems.map(i => {
            i.label = ENUMS.systemAccountNames[i.name]
            return i
          })
        })
        .catch(_ => {
          this.$store.commit('app/setNotification', {
            msg: this.$t('Views.Finance.failGetAccount'),
            type: 'error'
          })
        })
    },
    getRechargeMethods() {
      this.getPaymentMethodsAll().then(() => {
        this.rechargeMethods = this.paymentMethodsAll.items.filter(i => i.enable)
      })
    },
    onAccountClick(v) {
      // this.account = v
    },
    handleFormat(value, key) {
      this.$nextTick(() => {
        this[key] = value
      })
    },
    formatDate(date) {
      return format(date, 'YYYY-MM-DD')
    },
    formatPrice(num) {
      return this.$util.data.toThousands(num)
    },
    onRechargeAmountInput(value) {
      const v = value.match(/^\d*(\.?\d{0,2})/g)
      if (v != null && v.length === 1 && v[0] === '') {
        // 不能输入空格
        if (value.length > 0 && value.trim().length === 0) {
          this.$nextTick(() => {
            this.rechargeAmount = ''
          })
        }
      } else {
        if (v != null && v.length > 0) {
          const s = v[0]
          this.$nextTick(() => {
            if (parseFloat(s) <= 0) {
              this.rechargeAmount = s
            } else {
              const i = s.indexOf('.')
              if (i !== -1) {
                const strs = s.split('.')
                const last = strs[strs.length - 1]
                if (this.account && this.account.name === 'JPY') {
                  this.rechargeAmount = strs[0]
                } else {
                  if (last.length > 2) {
                    this.rechargeAmount = parseFloat(s).toFixed(2)
                  } else {
                    this.rechargeAmount = s // parseFloat(s).toFixed(2)
                  }
                }
              } else {
                if (s.length > 9) {
                  // 整数长度超过9位
                  this.rechargeAmount = s.substr(0, 9)
                } else {
                  // 整数长度没有超过9位
                  if (s.indexOf('.') === -1) {
                    this.rechargeAmount = s
                  }
                }
              }
            }
          })
        }
      }
    },
    handleInputDate(value) {
      this.date = this.formatDate(value, 'YYYY-MM-DD')
    },
    computeTitle(type) {
      switch (type) {
        case 'Ban':
          return this.$t('Views.Finance.discountDetail')
        case 'edit':
          return this.$t('Views.Finance.clientEdit')
        default:
          return this.$t('Views.Finance.sure')
      }
    },
    getPermission(name) {
      return this.$util.tool.hasPerm(name)
    }
  }
}
</script>

<style scoped>
.account-flex {
  display: flex;
  flex: 1 1 auto;
  flex-wrap: nowrap;
  min-width: 0;
}
.balance-card {
  width: 405px;
  height: 180px;
  border-radius: 10px;
  border-top: 4px solid #5BB85F;
}
.layout .account-flex:not(:last-child) {
  margin-right: 20px;
}
.layout .balance-card:not(:last-child) {
  margin-right: 20px;
}
.account-flex .theme--light.v-sheet {
  border-color: #5BB85F!important;
}
.total-title {
  text-align: center;
  font-size: 16px;
  font-weight: bold;
  color: #515151;
  margin-top: 48px;
}
.total-value {
  text-align: center;
  font-size: 28px;
  color: gray;
  font-weight: bolder;
  margin-bottom: 20px;
  margin-top: 10px;
}
.primary-text {
  color: #5BB85F;
}
.layout {
  position: relative;
}
.required-mark {
  color: red;
  font-size: 20px;
  line-height: 26px;
  vertical-align: middle;
  /* float: left; */
  position: absolute;
  top: 0;
  left: 0;
}
.fix-left {
  margin-left: 10px;
}
.fix-search-item {
  margin-top: 20px;
  margin-left: 10px;
}
</style>
